import React, { createContext, useContext } from 'react';
import type { AxiosInstance } from 'axios';
import { useMsal } from '@azure/msal-react';
import { createApiClient } from '../api/client';

interface ApiContextType {
  apiClient: AxiosInstance;
}

const ApiContext = createContext<ApiContextType | undefined>(undefined);

export const ApiProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { instance } = useMsal();
  const apiClient = createApiClient(instance);

  return <ApiContext.Provider value={{ apiClient }}>{children}</ApiContext.Provider>;
};

export const useApi = (): AxiosInstance => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApi must be used within ApiProvider');
  }
  return context.apiClient;
};
